import { IQuery, Topics } from '@zaplify/common';
import { ProspectDto } from '../prospects';

export class GetProspectByIdQuery extends IQuery<ProspectDto> {
    public static override readonly TOPIC = Topics.PROSPECTS;
    constructor(readonly prospectId: string) {
        super();
    }
}
